import { Autocomplete, Box, Button, Modal, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import { ICareTeam } from '../../../../Models/CareTeams/CareTeam.model';
import { RootState } from '../../../../reducers';
import { fetchTeams } from '../../../../store/careTeams.slice';
import { setCareTeam as setMemberCareTeam } from '../../../../store/careTeams.slice';
import { modalStyle } from '../../../../utils/constants';

interface AssignCareTeamModalProps {
    open: boolean;
    onClose: () => void;
    memberId: string;
}

const AssignCareTeamModal: React.FC<AssignCareTeamModalProps> = ({ open, onClose, memberId }) => {
    const dispatch = useAppDispatch();
    const { careTeams } = useSelector((state: RootState) => state.careTeams);
    const [careTeam, setCareTeam] = useState<ICareTeam | null>(null);

    useEffect(() => {
        if (open) {
            dispatch(fetchTeams(false));
        }
    }, [open, dispatch]);

    const handleSave = () => {
        if (careTeam) {
            dispatch(setMemberCareTeam(memberId, careTeam.Id));
            onClose();
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <Typography variant="h6" mb={2}>
                    Assign Care Team
                </Typography>
                {careTeam ? (
                    <>
                        <Autocomplete
                            options={careTeams.filter((team) => team.MaxTeamSize > team.AssignedMemberIds.length)}
                            getOptionLabel={(option) => option.Name}
                            value={careTeam}
                            onChange={(event, newValue) => setCareTeam(newValue)}
                            renderInput={(params) => <TextField {...params} label="Select Care Team" />}
                        />
                    </>
                ) : (
                    <Autocomplete
                        options={careTeams.filter((team) => team.MaxTeamSize > team.AssignedMemberIds.length)}
                        getOptionLabel={(option) => option.Name}
                        value={careTeam}
                        onChange={(event, newValue) => setCareTeam(newValue)}
                        renderInput={(params) => <TextField {...params} label="Select Care Team" />}
                    />
                )}
                <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={onClose} sx={{ mr: 1 }}>
                        Cancel
                    </Button>
                    <Button variant="contained" onClick={handleSave} disabled={!careTeam}>
                        Save
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default AssignCareTeamModal;
